const countyConfigNotableDatesReducer = (state = [{}], action) => {
  switch (action.type) {
    case 'LANDSHARK_COUNTY_CONFIG_NOTABLE_DATES':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigNotableDatesReducer;